import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DashboardPage from "../pages/dashboard/page";
import SignPage from "../pages/sign/page";
import ResourcePage from "../pages/resource/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sign",
    element: <SignPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/resource",
    element: <ResourcePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;